import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {InputSearchSpecialist} from '@/features/projects/specialists/components/input-search-specialist/InputSearchSpecialist'
import {SpecialistCardDetails} from '@/features/projects/specialists/components/specialist-card-details/SpecialistCardDetails'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const ProjectFormSpecialistSchema = ProjectFieldsSchema.pick({
    id: true,
    specialist: true,
    referringProject: true
})
type ProjectFormSpecialistSchema = z.infer<typeof ProjectFormSpecialistSchema>

export const ProjectFormSpecialistField = ({hideAddSpecialistButton}: {hideAddSpecialistButton?: boolean}) => {
    const {t} = useTranslation()
    const {control} = useFormContext<ProjectFormSpecialistSchema>()
    const {field} = useController({control, name: 'specialist'})
    const projectId = useWatch({control, name: 'id'})
    const referringProject = useWatch({control, name: 'referringProject'})

    return (
        <>
            <GridItem spanColumn={2} direction="column" gap={2} fullWidth>
                <InputSearchSpecialist
                    label={t('projects:sender')}
                    placeholder={t('projects:select_specialist_placeholder')}
                    onCreateSpecialist={specialist => field.onChange(specialist)}
                    hideAddSpecialistButton={hideAddSpecialistButton}
                    {...field}
                />
            </GridItem>
            {field.value && (
                <GridItem spanColumn={3}>
                    <SpecialistCardDetails
                        specialist={field.value}
                        onRemoveSpecialist={!projectId || referringProject ? () => field.onChange(null) : undefined}
                    />
                </GridItem>
            )}
        </>
    )
}
